import { buildDayModel, idOf, isFinished, isMeeting } from './workspaceDay';

export function coordinates(value) {
  if (!value) return null;
  const rawLat = value.latitude ?? value.lat;
  const rawLon = value.longitude ?? value.lng ?? value.lon;
  if ([rawLat, rawLon].some(v => v === null || v === undefined || typeof v === 'boolean' || String(v).trim() === '')) return null;
  const latitude = Number(rawLat), longitude = Number(rawLon);
  return Number.isFinite(latitude) && Number.isFinite(longitude) && Math.abs(latitude) <= 90 && Math.abs(longitude) <= 180
    ? { latitude, longitude } : null;
}

export function locationTime(value) {
  if (value === null || value === undefined || value === '') return null;
  const time = typeof value === 'number' ? value < 1e12 ? value * 1000 : value : Date.parse(value);
  return Number.isFinite(time) ? time : null;
}

export function locationState(location, now = Date.now()) {
  if (!coordinates(location)) return 'missing';
  const time = locationTime(location.timestamp);
  if (time === null || time > now + 60000) return 'undated';
  return now - time <= 5 * 60000 ? 'recent' : 'stale';
}

export function validDay(day) {
  return /^\d{4}-\d{2}-\d{2}$/.test(day) && !Number.isNaN(Date.parse(`${day}T00:00:00+08:00`)) && new Date(`${day}T12:00:00Z`).toISOString().slice(0, 10) === day;
}

export function dayRecords(visits, plans, day, userId) {
  return buildDayModel(visits, plans, [], day).records.filter(v => idOf(v.user) === String(userId));
}

export function meetingState(visit) {
  if (visit.status === 'cancelled') return 'cancelled';
  if (isFinished(visit)) return 'completed';
  if (visit.status === 'in_progress' && visit.startTime) return 'in_progress';
  if (visit.status === 'completed') return 'unconfirmed';
  return 'planned';
}

export function meetingPosition(visit) {
  // A scheduled appointment has no measured position. Never borrow GPS from a nearby track point.
  return visit.startTime ? coordinates(visit.startLocation) || coordinates(visit.endLocation) : null;
}

export const finishedMeetings = records => records.filter(v => isMeeting(v) && isFinished(v));

export function latestLocations(rows) {
  const result = new Map();
  for (const row of rows) {
    const userId = idOf(row.userId || row.user);
    if (!userId || !coordinates(row)) continue;
    const previous = result.get(userId);
    if (!previous || (locationTime(row.timestamp) ?? -Infinity) > (locationTime(previous.timestamp) ?? -Infinity)) result.set(userId, { ...row, ...coordinates(row) });
  }
  return result;
}
